import { Component, Input } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';

/** Étapes de la vie d'un import, dans l'ordre où l'utilisateur les traverse. */
export type ImportStepId = 'UPLOAD' | 'EXTRACTION' | 'LOAD';

export interface ImportStep {
    id: ImportStepId;
    label: string;
    state: 'done' | 'current' | 'todo';
    /** Précision affichée sous l'étape en cours, ex. « Validation des lignes ». */
    hint?: string | null;
}

/**
 * Fil des étapes d'un import : transfert du fichier, lecture, import des lignes.
 *
 * Volontairement sans pourcentage global : il supposerait de connaître le poids relatif de chaque
 * étape, ce qui est faux ici — le nombre de lignes n'est connu qu'à la fin de la lecture, et l'import
 * n'est lancé qu'une fois les erreurs corrigées, donc après une décision humaine de durée inconnue.
 * Le fil situe l'avancement, la barre de l'étape en cours donne le détail.
 *
 * Partagé par la fenêtre de transfert (écran de la liste des imports) et la carte de progression
 * (écran de tâche) : les deux moitiés du parcours se lisent de la même façon.
 */
@Component({
    selector: 'dmp-import-steps',
    standalone: true,
    imports: [NgClass, NgForOf, NgIf],
    templateUrl: './import-steps.component.html',
    styleUrls: ['./import-steps.component.scss']
})
export class ImportStepsComponent {
    @Input() steps: ImportStep[] = [];
}
